module.exports = __webpack_public_path__ + "img/r-146.67c6b612.jpg";